import { VIEW_BASEURL } from '../config';
import { useDashboardFirstMetaSiteId } from './useDashboardFirstMetaSiteId';
import { useSiteCreationFolderId } from './useSiteCreationFolderId';

export const useViewUrl = (data: { slug: string }) => {
  const { slug } = data;
  const dashboardFirstMetaSiteId = useDashboardFirstMetaSiteId();
  const siteCreationFolderId = useSiteCreationFolderId();

  const viewerUrl = new URL(`${VIEW_BASEURL}/${slug}`);

  if (dashboardFirstMetaSiteId) {
    viewerUrl.searchParams.append(
      'dashboardFirstMetaSiteId',
      dashboardFirstMetaSiteId,
    );
  }
  if (siteCreationFolderId) {
    viewerUrl.searchParams.append('siteCreationFolderId', siteCreationFolderId);
  }

  return viewerUrl.href;
};
